/** @format */

import {MouseEvent, useState} from 'react';

import MenuItem from '@mui/material/MenuItem';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import {Trans} from 'react-i18next';
import SettingsIcon from '@mui/icons-material/Settings';

import {useNavigate} from 'react-router-dom';

import {Box, Button, Typography} from '@mui/material';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import {CategoriesFromQuery, GroupType} from 'pages/HomeGrouping/types';

import {StyledMenu} from './components/StyledMenu';
import {HomeGroupingSelectorClasses as classes, HomeGroupingSelectorRoot as Root} from './styles';
import {BackgroundDotIcon} from '../../assets/Icons';

import {StyledPopover} from '../StyledPopover';

interface Props {
  onChange: (group: GroupType) => void;
  categories: CategoriesFromQuery[];
  chosenFiltering: GroupType;
}

const CategorySelector = ({onChange, categories, chosenFiltering}: Props) => {
  const [hintAnchorEl, setHintAnchorEl] = useState<null | HTMLElement>(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

  const navigate = useNavigate();

  const handleHintOpen = (event: MouseEvent<HTMLDivElement>) => {
    setHintAnchorEl(event.currentTarget);
  };

  const handleHintClose = () => {
    setHintAnchorEl(null);
  };

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleCategoryChoose = (type: GroupType) => {
    if (type === 'default') {
      onChange('default');
    } else if (type === 'settings') {
      navigate('/home/settings/grouping');
    } else {
      onChange(type);
    }

    handleMenuClose();
  };

  return (
    <Root>
      <Box
        className={classes.groupButtonHint}
        onMouseEnter={handleHintOpen}
        onMouseLeave={handleHintClose}
        data-testid='group-icon'
      >
        <BackgroundDotIcon />
      </Box>

      <Button
        className={classes.groupButton}
        onClick={handleMenuOpen}
        data-testid='category-selector'
      >
        <Trans>
          <Typography>
            {chosenFiltering === 'default'
              ? 'Не группировать'
              : categories.find(v => v.id === chosenFiltering)?.name || ''}
          </Typography>
        </Trans>
        <KeyboardArrowDownIcon className={classes.groupButtonIcon} />
      </Button>

      <StyledMenu anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => handleCategoryChoose('default')}
          disableRipple
          data-testid='category-no-group'
        >
          <ToggleOffIcon />

          <Trans>Не группировать</Trans>
        </MenuItem>
        {categories.map(v => (
          <MenuItem key={v.id} onClick={() => handleCategoryChoose(v.id)} disableRipple>
            <Trans>{v.name}</Trans>
          </MenuItem>
        ))}
        <MenuItem
          onClick={() => handleCategoryChoose('settings')}
          disableRipple
          data-testid='category-settings'
        >
          <SettingsIcon />

          <Trans>Настройки</Trans>
        </MenuItem>
      </StyledMenu>

      <StyledPopover
        open={Boolean(hintAnchorEl)}
        anchorEl={hintAnchorEl}
        onClose={handleHintClose}
        disableScrollLock={false}
        sx={{pointerEvents: 'none'}}
      >
        <Trans>Группировать проекты</Trans>
      </StyledPopover>
    </Root>
  );
};

export {CategorySelector};
